import { PartnerFullNameValidation } from './types'

export const validatePartnerFullName = (fullName: string, partnerFullName: string): PartnerFullNameValidation => {
  console.log('fullName', fullName)
  console.log('partnerFullName', partnerFullName)
  if (!fullName.trim() || !partnerFullName.trim()) {
    return {
      isValid: false,
      error: 'Please enter both names',
    }
  }

  console.log('fullName.trim().length', fullName.trim().length)
  console.log('partnerFullName.trim().length', partnerFullName.trim().length)
  if (fullName.trim().length < 1 || partnerFullName.trim().length < 1) {
    return {
      isValid: false,
      error: 'Each name must be at least 1 character',
    }
  }

  console.log('fullName.trim().length > 150', fullName.trim().length > 150)
  console.log('partnerFullName.trim().length > 150', partnerFullName.trim().length > 150)
  if (fullName.trim().length > 150 || partnerFullName.trim().length > 150) {
    return {
      isValid: false,
      error: 'Each name must be less than 150 characters',
    }
  }

  // Check if name contains only letters, spaces, numbers, hyphens, and apostrophes
  const nameRegex = /^[a-zA-Z0-9\s\-']+$/
  if (!nameRegex.test(fullName.trim()) || !nameRegex.test(partnerFullName.trim())) {
    return {
      isValid: false,
      error: 'Names can only contain letters, spaces, hyphens, and apostrophes',
    }
  }

  return {
    isValid: true,
    error: '',
  }
}
